import { render, staticRenderFns } from "./UsersTableForLazyLoadingWithResize.vue?vue&type=template&id=12f509f9"
import script from "./UsersTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
export * from "./UsersTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports